import React from 'react'
import InfoTooltip from 'components/InfoTooltip'
import "./infoCard.scss"

// Id target tooltip diturunkan dari judul kartu supaya stabil dan unik per
// halaman, sekaligus aman dipakai sebagai selektor CSS oleh reactstrap.
const toTooltipId = (title) =>
  `info-card-${String(title)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')}`

const InfoCard = ({ content, onClick }) => {
  const {
    CardIcon,
    title,
    data,
    key,
    styleBackground,
    styleText,
    tooltip
  } = content

  return (
    <div className='info-card' key={key} onClick={onClick} style={styleBackground}>
      <CardIcon />
      <span className='card-title' style={styleText}>
        {title}
        {tooltip && <InfoTooltip id={toTooltipId(title)} text={tooltip} />}
      </span>
      <span className='card-data' style={styleText}>{data}</span>
    </div>
  )
}

export default InfoCard
